import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzButton, BringzzIcon, BringzzText, BringzzInput
} from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

const EditDoctorVerificationView = () => {
    const { user, refreshUserData } = useAuth()
    const { backPress, navigate } = useNavigation();
    const [doctorType, setDoctorType] = useState(user.doctorType || '')
    const [doctorId, setDoctorId] = useState(user.doctorId || '')
    const [doctorUid, setdoctorUid] = useState(user.doctorUid || '')
    const { sendRequest, loading } = useRequest();
    const { t } = useTranslation();

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: <BringzzText tag='h2'>{t('component.account.doctor_verification.title')}</BringzzText>,
            }}
            footer={
                <div className='pb-28 px-6'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={async () => {
                            await sendRequest({
                                method: 'POST',
                                url: `/module/profile/changeDoctor`,
                                data: {
                                    doctorType,
                                    doctorId,
                                    doctorUid
                                }
                            })
                                .then(response => {
                                    if (response.status === 'success') {
                                        refreshUserData()
                                        backPress()
                                    }
                                })
                                .catch(error => {
                                    console.log(error);
                                });
                        }}
                        disabled={loading || (!doctorType && !doctorId && !doctorUid)}
                    >
                        {t('common.save')}
                    </BringzzButton>
                </div>
            }
        >
            <div className='p-6 space-y-4'>
                <BringzzInput 
                    onChange={(e, v, value) => setDoctorType(value)} 
                    defaultValue={user.doctorType} 
                    id='doctorType' 
                    label={t('component.account.doctor_verification.type.label')} 
                    containerClassname="w-full" 
                    placeholder={t('component.account.doctor_verification.type.placeholder')} 
                />
                <BringzzInput 
                    onChange={(e, v, value) => setDoctorId(value)} 
                    defaultValue={user.doctorId} 
                    id='doctorId' 
                    label={t('component.account.doctor_verification.id.label')} 
                    containerClassname="w-full" 
                    placeholder={t('component.account.doctor_verification.id.placeholder')} 
                />
                <BringzzInput 
                    onChange={(e, v, value) => setdoctorUid(value)} 
                    defaultValue={user.doctorUid} 
                    id='doctorUid' 
                    label={t('component.account.doctor_verification.uid.label')} 
                    containerClassname="w-full" 
                    placeholder={t('component.account.doctor_verification.uid.placeholder')} 
                />
            </div>
        </BringzzPageContainer>
    );
}

export default EditDoctorVerificationView;
